import React, { FC, useEffect } from 'react'
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles'

import { TRANSLATIONS as T } from '../../../../constants/translations-constants'
import { LMBasicV3FSM, LDContainerV2FSM, Typography } from '@dg-shared'
import { useTranslate } from '../../../../hooks/shared'
import { FlowServiceType } from '../../../../types/interface/fsm.interface'
import { Events } from '../../../../FSM/shared/constants'
import useLogic from '../useLogic'
import { Card } from '@material-ui/core'
import CompareList from './CompareList'
import PageWrapper from '@dg-shared/PageWrapper'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      height: '100%',
      flexDirection: 'column',
      alignItems: 'center',
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(5),
      },
      [theme.breakpoints.down('sm')]: {
        background: 'none',
        boxShadow: 'none',
      },
    },
    title: {
      marginBottom: theme.spacing(2.5),
      [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(0),
      },
    },
  })
)

export type PagePropsType = {
  service: FlowServiceType
}

const QBCompareListPage: FC<PagePropsType> = (props) => {
  const { service } = props
  const { t } = useTranslate(T.OFFER_COMPARE_POLICY)
  const classes = useStyles()
  const { insurelyResults, selectedInsurelyQuote, quote } = useLogic(service)

  useEffect(() => {
    if (
      insurelyResults === null ||
      (Array.isArray(insurelyResults) && insurelyResults.length < 1)
    ) {
      service.send(Events.INSURELY_NO_OFFERS_FOUND)
    }
    // TODO: FIx with using correct deps in [] and useCallback. Left here to not break anything
    // eslint-disable-next-line
  }, [insurelyResults])

  useEffect(() => {
    if (selectedInsurelyQuote && quote) {
      service.send(Events.NEXT)
    }
  }, [selectedInsurelyQuote, quote, service])

  const content = (
    <Card elevation={3} className={classes.container}>
      <CompareList />
    </Card>
  )

  return (
    <PageWrapper
      mobile={LMBasicV3FSM}
      desktop={LDContainerV2FSM}
      breadcrumbsBtnText={t(`back`)}
      breadcrumbsStepPercentage={60}
    >
      <Typography className={classes.title} type={'h1'}>
        {t('title')}
      </Typography>
      {content}
    </PageWrapper>
  )
}

export default QBCompareListPage
